import firebase from 'firebase';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/storage';

const config = {
    apiKey: "AIzaSyCe6zz9XWs-3Cv_MIWxcvp0eBRjIQ7dMQ0",
    authDomain: "adosacadmin.firebaseapp.com",
    databaseURL: "https://adosacadmin.firebaseio.com",
    projectId: "adosacadmin",
    storageBucket: "adosacadmin.appspot.com",
    messagingSenderId: "20568785290",
    appId: "1:20568785290:web:418f49309f6e8641dac873",
    measurementId: "G-B5NVVJ37B6"
};

class Firebase {
    constructor() {

        // app.initializeApp(config);

        // this.auth = app.auth();
        // this.database = app.database;
        // this.db = app.database();
        // this.storage = app.storage();

        if (!firebase.apps.length) {
            firebase.initializeApp(config);
        }
        this.auth = firebase.auth();
        this.database = firebase.database;
        this.db = firebase.database();
        this.storage = firebase.storage();
    }

    // *** Auth API ***
    doSignInWithEmailAndPassword = (email, password) =>
        this.auth.signInWithEmailAndPassword(email, password);

    doSignOut = () => this.auth.signOut();

    doPasswordReset = email => this.auth.sendPasswordResetEmail(email);

    doPasswordChange = password =>
        this.auth.currentUser.updatePassword(password);



    // *** TimeStamp
    timestamp = () => this.database.ServerValue.TIMESTAMP;

    // *** Count API ***
    count = () => this.db.ref('count');

    // *** News API ***
    news = () => this.db.ref('news');
    newsItem = (uid) => this.db.ref('news').child(uid);

    // *** Legislation API ***
    legislations = () => this.db.ref('legislations');
    legislation = (uid) => this.db.ref('legislations').child(uid);

    // *** Legislation API ***
    institutionals = () => this.db.ref('institutionals');
    institutional = (uid) => this.db.ref('institutionals').child(uid);

    // *** Message API ***
    messages = () => this.db.ref('messages');
    message = (uid) => this.db.ref('messages').child(uid);

    // *** Offer API ***
    offers = () => this.db.ref('offers');
    offer = (uid) => this.db.ref('offers').child(uid);

    // *** Classification Junta  API ***
    juntas = () => this.db.ref('juntas');
    junta = (uid) => this.db.ref('juntas').child(uid);

    // *** Licenses Regimen  API ***
    regimens = () => this.db.ref('regimens');
    regimen = (uid) => this.db.ref('regimens').child(uid);

    // *** Storage API ***
    files = () => this.storage.ref('files');
    folder = (folder) => this.storage.ref('files').child(folder);
    file = (folder, filename) => this.folder(folder).child(filename);
}

export default Firebase;